import { Component } from '@angular/core';

@Component({ standalone: true, template: `<div class="container-fluid p-4"><div class="card card-lift p-4"><h4>Rates</h4><p class="text-secondary mb-0">Migrated route scaffold.</p></div></div>` })
export class RatesPage {}
